import { render, staticRenderFns } from "./NewTeam.vue?vue&type=template&id=362370f5"
import script from "./NewTeam.vue?vue&type=script&lang=js"
export * from "./NewTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports